import { CacheMode } from '../types';
import { createAbortError, createPromise, proxyResponseWithAdditionalNext, } from './utils';
import { ROEFetcherRequest } from './roe';
import { SWRFetcherRequest } from './swr';
/**
 * Polling request, handles client polling
 */
export class PollingFetcherRequest {
    constructor(requestControl, cacheKey, options, request, logger) {
        this.requestControl = requestControl;
        this.cacheKey = cacheKey;
        this.options = options;
        this.request = request;
        this.logger = logger;
        this.isAborted = false;
    }
    run() {
        const responseControls = createPromise();
        this.responseResolve = responseControls.resolve;
        let isFirstRequest = true;
        const optionsWithNoCache = Object.assign({}, this.options, {
            cacheMode: CacheMode.NoCache,
        });
        const pollingLoop = () => {
            var _a;
            (_a = this.logger) === null || _a === void 0 ? void 0 : _a.call(this, 'start polling');
            clearTimeout(this.pollingTimeout);
            // first request may uses cache while followed requests doesn't need cache
            const options = isFirstRequest ? this.options : optionsWithNoCache;
            isFirstRequest = false;
            this.innerRequest =
                this.options.retryTimes > 0
                    ? new ROEFetcherRequest(this.requestControl, this.cacheKey, options, this.request, this.logger)
                    : new SWRFetcherRequest(this.requestControl, this.cacheKey, options, this.request, this.logger);
            this.innerRequest.run().then((response) => {
                // this.responseResolve might be replaced inside the creating proxy response method
                const resolve = this.responseResolve;
                if (this.isAborted) {
                    resolve(createAbortError());
                    return;
                }
                resolve(proxyResponseWithAdditionalNext(response, () => {
                    var _a, _b;
                    (_a = this.logger) === null || _a === void 0 ? void 0 : _a.call(this, 'polling request settled');
                    if (this.isAborted) {
                        return;
                    }
                    const promiseControls = createPromise();
                    this.responseResolve = promiseControls.resolve;
                    this.pollingTimeout = setTimeout(pollingLoop, this.options.pollingWaitTime * 1000);
                    (_b = this.logger) === null || _b === void 0 ? void 0 : _b.call(this, 'next polling scheduled');
                    return promiseControls.promise;
                }));
            });
        };
        // start polling
        pollingLoop();
        return responseControls.promise;
    }
    abort() {
        var _a, _b, _c;
        if (this.isAborted) {
            return;
        }
        this.isAborted = true;
        (_a = this.logger) === null || _a === void 0 ? void 0 : _a.call(this, 'aborted');
        (_b = this.innerRequest) === null || _b === void 0 ? void 0 : _b.abort();
        (_c = this.responseResolve) === null || _c === void 0 ? void 0 : _c.call(this, createAbortError());
        clearTimeout(this.pollingTimeout);
    }
}
